import React from 'react';
import Pressable from "react-native-web/dist/exports/Pressable";
import StyleSheet from "react-native-web/dist/exports/StyleSheet";
import PropTypes from 'prop-types';

/**
 * @typedef {import('react-native').PressableProps} PressableProps
 */

/**
 * InlinePressable is an alternative to React Native's Pressable that works better when nested
 * inline inside Text. It accepts the same props as React Native's Pressable.
 *
 * On Web it simply passes its props to Pressable and defaults to `inline-flex` instead of `flex`.
 *
 * @param {PressableProps} PressableProps
 */
import { jsx as _jsx } from "react/jsx-runtime";
const InlinePressable = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    inlineFlex = true,
    style,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(Pressable, {
    ref: ref,
    style: pressState => [typeof style === 'function' ? style(pressState) : style, staticStyles[inlineFlex ? 'inlineFlex' : 'inline']],
    ...props,
    children: pressState => typeof children === 'function' ? children(pressState) : children
  });
});
InlinePressable.displayName = 'InlinePressable';
InlinePressable.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  inlineFlex: PropTypes.bool,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func])
};
const staticStyles = StyleSheet.create({
  inline: {
    // Stop Pressable defaulting to (block) flex
    display: 'inline'
  },
  inlineFlex: {
    display: 'inline-flex'
  }
});
export default InlinePressable;